import classNames from 'classnames'
import css from './Loader.styles.scss'

interface LoaderProps {
  style?: Record<string, unknown>
  className?: string
}

const Loader = ({ style = {}, className }: LoaderProps) => (
  <div className={classNames(css.Loader, className)} style={style}>
    <div className={css.Loader__Wrapper}>
      <div className={css.Loader__Arch} />
    </div>
  </div>
)

export default Loader
